import { render, staticRenderFns } from "./DeclareListItem.vue?vue&type=template&id=26a2277b&scoped=true&"
import script from "./DeclareListItem.vue?vue&type=script&lang=js&"
export * from "./DeclareListItem.vue?vue&type=script&lang=js&"
import style0 from "./DeclareListItem.vue?vue&type=style&index=0&id=26a2277b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a2277b",
  null
  
)

export default component.exports